// @ts-check
import React from 'react';
import { useContext } from "react";
import ContentPageContext from "@/src/cms/context/ContentPageContext";
import Hero from "@/src/shared/components/Hero";
import { Skeleton } from "antd";
import Sanitize from "@/src/shared/components/Sanitize";

export default function ContentHero() {
  const value = useContext(ContentPageContext);

  if (!value) {
    throw new Error('ContentHero must be wrapped with ContentPageContext.Provider or ContentPageContextProvider')
  }

  const {
    loading,
    hero
  } = value;
  
  return (
    <Hero
      title={loading ? <Skeleton title={{ width: '50%' }} paragraph={false} /> : hero.headline}
      subTitle={loading ? '' : hero.subTitle}
      type={hero.image.id ? 'image' : 'default'}
      bgImage={`${process.env.NEW_API_URL}image/file?area=c&id=${hero.image.id}`}
    >
      {loading ? (
        <Skeleton title={false} paragraph={{ rows: 1, width: '75%' }} />
      ) : (
        <Sanitize>{hero.description}</Sanitize>
      )}
    </Hero>
  );
}